export const FUTURE_BOOKINGS_WARNING_MESSAGE =
  "Uh oh, this change will impact future bookings and sessions. Please update the conflicting orders and sessions before proceeding.";
